<template>
  <div>
    <b-row>
      <b-col cols="12"  md="4" class="cui__utils__heading">
        <strong>Reportes</strong>
      </b-col>
      <b-col class="m-2">
        <a-dropdown placement="bottomRight" style="position: absolute;right:1em;z-index:10;" :trigger="['click']">
        <button type="button" class="btn btn-light">
          <i class="fe fe-more-vertical" />
        </button>
        <a-menu slot="overlay">
          <a-menu-item>
            <a-button type="link" id="1" @click="downloadUsersWithBalance(true)" icon="download">Descargar Reporte de usuarios con saldo</a-button>
          </a-menu-item>
          <a-menu-item v-if="comboCheck">
            <a-button type="link" id="1" @click="downloadUsersWithBalance(false)" icon="download">{{`Descargar Reporte de usuarios con ${comboName.toLowerCase()}s`}} </a-button>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="3">
        <label for="example-datepicker">Fecha inicial</label>
        <b-form-datepicker id="example-datepicker" v-model="startDate"  placeholder="Fecha inicial" class="mb-2" value-as-date></b-form-datepicker>
        <!-- <p>Value: '{{ startDate }}'</p> d-flex flex-row justify-content-center -->
      </b-col>
      <b-col cols="12" md="3">
        <label for="example-datepicker">Fecha final</label>
        <b-form-datepicker id="example-datepicker2" v-model="endDate"  placeholder="Fecha final" class="mb-2" value-as-date></b-form-datepicker>
        <!-- <p>Value: '{{ startDate }}'</p> -->
      </b-col>
      <b-col cols="12" md="3" align-self="end">
        <b-button block squared variant="outline-success" class="btn-rounded mr-2 mb-2" v-on:click="downloadRechargesReport()">
          <i class="fe fe-download mr-1"></i>
          Descargar lista de recargas
        </b-button>
      </b-col>
      <b-col cols="12" md="3" align-self="end">
        <b-button block squared variant="outline-success" class="btn-rounded mr-2 mb-2" v-on:click="downloadSalesReport()">
          <i class="fe fe-download mr-1"></i>
          Descargar lista de ventas
        </b-button>
      </b-col>
    </b-row>
    <a-skeleton active  v-show="isLoading"/>
    <a-alert message="Error en el rango de fechas" type="warning" show-icon  v-show="!areDatesCorrectly" />
    <div v-show="!isLoading && areDatesCorrectly">
      <div class="row mt-3">
        <div class="col-md-6">
          <div class="card bg-primary border-0">
            <div class="card-body">
              <kit-general-24 title="Total de recargas" :value="data.totalMoneyCollected"/>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card bg-light">
            <div class="card-body">
              <kit-general-24v1 title="Total de ventas" :value="data.totalMoneySales"/>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="card">
            <div class="card-body">
              <kit-general-2v1 title="Cantidad de productos vendidos" subTitle="Total de productos vendidos" :value="data.totalProductsSold" />
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card">
            <div class="card-body">
              <kit-general-2v1 title="Cantidad de recargas" subTitle="Total de recargas realizadas" :value="data.totalRecharges" />
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card">
            <div class="card-body">
              <kit-general-2v1 title="Cantidad de ventas" subTitle="Total de ventas realizadas" :value="data.totalSales" />
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="comboCheck">
        <div class="col-md-4 offset-2">
          <div class="card">
            <div class="card-body">
              <kit-general-2 :title="'Cantidad de ' + comboName + 's vendidos'" :subTitle="'Total de ' + comboName.toLowerCase() + 's vendidos'" :value="data.totalBoughtCombos" />
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card">
            <div class="card-body">
              <kit-general-2 :title="'Cantidad de ' + comboName + 's recargados'" :subTitle="'Total de ' + comboName.toLowerCase() + 's recargados'" :value="data.totalCombosRecharged" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import KitGeneral24 from '@/components/kit/widgets/General/24'
import KitGeneral24v1 from '@/components/kit/widgets/General/24v1'
import KitGeneral2 from '@/components/kit/widgets/General/2'
import KitGeneral2v1 from '@/components/kit/widgets/General/2v1'
import apiClient from '@/services/axios'
import apiClient2 from '@/services/axios/v2'
import { consts, currencyFormatPesos, showErrorMessage } from '@/services/utilities'
import moment from 'moment'
import axios from 'axios'
import store from 'store'

export default {
  components: {
    KitGeneral24,
    KitGeneral24v1,
    KitGeneral2,
    KitGeneral2v1,
  },
  data() {
    return {
      isLoading: true,
      errorDates: false,
      startDate: '',
      endDate: '',
      data: {
        totalMoneyCollected: '0',
        totalMoneySales: '0',
        totalProductsSold: '0',
        totalBoughtCombos: '0',
        totalCombosRecharged: '0',
        totalRecharges: '0',
        totalSales: '0',
      },
      accessToken: '',
      comboCheck: false,
      comboName: '',
    }
  },
  computed: {
    areDatesCorrectly: function () {
      if (this.startDate <= this.endDate) {
        this.loadData()
        return true
      }
      return false
    },
  },
  async beforeRouteEnter (to, from, next) {
    await apiClient2.get('/schoolParam/active').then(response => {
      next(vm => vm.setData('', response.data.data))
    }).catch(err => {
      next(vm => vm.setData(err, [])) // TODO Mostrar error
    })
  },
  methods: {
    setData (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        if (data) {
          for (const param of data) {
            if (param.key === consts.params.COMBO) {
              this.comboCheck = true
              this.comboName = param.value
            }
          }
        }
      }
    },
    loadData() {
      this.isLoading = true
      const start = moment(this.startDate).format('YYYY-MM-DD')
      const end = moment(this.endDate).format('YYYY-MM-DD')
      apiClient.get(`/reports/sales?startDate=${start}&endDate=${end}`).then(response => {
        this.data = response.data
        this.data.totalMoneyCollected = currencyFormatPesos(response.data.totalMoneyCollected)
        this.data.totalMoneySales = currencyFormatPesos(response.data.totalMoneySales)
        this.isLoading = false
      }).catch(err => {
        this.$notification.success({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(err),
        })
      })
    },
    setInitialData(err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.data = data
        this.data.totalMoneyCollected = currencyFormatPesos(data.totalMoneyCollected)
        this.data.totalMoneySales = currencyFormatPesos(data.totalMoneySales)
        this.isLoading = false
      }
    },
    downloadRechargesReport() {
      const start = moment(this.startDate).format('YYYY-MM-DD')
      const end = moment(this.endDate).format('YYYY-MM-DD')
      const endNameReport = moment(this.endDate).format('YYYY-MM-DD')
      const headers = {
        Authorization: `Bearer ${this.accessToken}`,
        AccessToken: this.accessToken,
      }
      axios({
        url: process.env.VUE_APP_API_URL + `/reports/sales/recharges?startDate=${start}&endDate=${end}`,
        method: 'GET',
        responseType: 'blob', // Important
        headers: headers,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Reporte_de_recargas_${start}_${endNameReport}.xlsx`) // or any other extension
        document.body.appendChild(link)
        link.click()
      })
    },
    downloadUsersWithBalance(isBalance = true) {
      const headers = {
        Authorization: `Bearer ${this.accessToken}`,
        AccessToken: this.accessToken,
      }
      axios({
        url: `${process.env.VUE_APP_API_URL_V2}/sales/reports/usersBalance`,
        method: 'GET',
        responseType: 'blob', // Important
        params: {
          isBalance,
        },
        headers: headers,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        let fileName = 'Reporte_de_usuarios_con_'
        fileName += (isBalance) ? 'saldo' : this.comboName.toLowerCase()
        link.setAttribute('download', `${fileName}.xlsx`) // or any other extension
        document.body.appendChild(link)
        link.click()
      }).catch((error) => {
        console.error('Error descargando el reporte:', error)
        // Handle the error appropriately in your application
      })
    },
    downloadSalesReport() {
      const start = moment(this.startDate).format('YYYY-MM-DD')
      const end = moment(this.endDate).format('YYYY-MM-DD')
      const endNameReport = moment(this.endDate).format('YYYY-MM-DD')
      const headers = {
        Authorization: `Bearer ${this.accessToken}`,
        AccessToken: this.accessToken,
      }
      axios({
        url: process.env.VUE_APP_API_URL + `/reports/sales/sales?startDate=${start}&endDate=${end}`,
        method: 'GET',
        responseType: 'blob', // Important
        headers: headers,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Reporte_de_ventas_${start}_${endNameReport}.xlsx`) // or any other extension
        document.body.appendChild(link)
        link.click()
      })
    },
  },
  created() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const minDate = new Date(today)
    minDate.setMonth(minDate.getMonth() - 1)
    this.startDate = minDate
    this.endDate = today
    this.accessToken = store.get('accessToken')
  },
}
</script>
